module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-2-photo-8-cf89a00fc340dd2feb2a799124520654.webp";